import { AxiosRequestConfigDef } from "@/event-bus";
import {
  SimpleTaxDutyConfigurationDTO,
  ZonosCalculateResponseDTO,
  ZonosLandedCostResponseDTO,
  ZonosProformaDTO
} from "@/model/data.model";
import store from "@/vuex/store";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export class TaxDutyService {
  calculate(data: ZonosProformaDTO) {
    const config: AxiosRequestConfigDef = {
      method: "POST",
      data,
      url: store.getters.BASE_API_URL + "/tax-and-duties/calculate"
    };
    return axios
      .request(config)
      .then(res => {
        return res.data as ZonosCalculateResponseDTO;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  initTaxDutyUserConfiguration() {
    const config: AxiosRequestConfigDef = {
      method: "GET",
      params: {
        legalEntityId: store.getters["customer/info"].customerId,
        username: store.getters["user"].username
      },
      url:
        store.getters.BASE_API_URL +
        "/tax-and-duties/counters/users/configuration"
    };
    return axios
      .request(config)
      .then(res => {
        const configuration = res.data as SimpleTaxDutyConfigurationDTO;
        store.commit("customer/setTaxDutyEnabled", configuration.active);
        store.commit(
          "customer/setTaxDutyZonosEnabled",
          configuration.zonosActive
        );
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
      });
  }

  getZonosLandedCost(zonosId: string) {
    const config: AxiosRequestConfigDef = {
      method: "GET",
      params: {
        zonosId
      },
      url: store.getters.BASE_API_URL + "/tax-and-duties/zonos-landed-cost"
    };
    return axios
      .request(config)
      .then(res => {
        return res.data as ZonosLandedCostResponseDTO;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  getZonosCourierServices() {
    const config: AxiosRequestConfigDef = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/tax-and-duties/couriers/services"
    };
    return axios
      .request(config)
      .then(res => {
        const data = res.data as {
          couriersServices: number[];
          guaranteeDisabledCourierServices: number[];
        };
        return data;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  getCurrentMonthCallAmount() {
    const config: AxiosRequestConfigDef = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/tax-and-duties/counters/current_month"
    };
    return axios
      .request(config)
      .then(res => {
        const response = res.data as { totalCalls: number };
        return response.totalCalls;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  getDetailsExportFile() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `${store.getters.BASE_API_URL}/tax-and-duties/counters/details_export`,
      responseType: "arraybuffer"
    };
    return axios
      .request(config)
      .then((res: AxiosResponse) => {
        return res.data as ArrayBuffer;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }
}
